/*
 * @Description:账户管理 - 短信账户与充值
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import { Button, Dialog, Icon, Loading, Message, NumberPicker, Rating, Tab, Table } from '@alifd/next';
import style from './index.module.scss';
import ParagraphTitle from '@/components/ParagraphTitle';
import { Servlets } from '@/service';
import Cookie from 'js-cookie';
import LzMsg from '@/components/common/LzMsg';

const TabItem = Tab.Item;
const list = [
  { companyName: '陆泽科技有限公司', account: '532030100100480753', unionNumber: '309222000041', accountBank: '兴业银行大连开发区支行' }
];
/** 短信账户与充值 */
const SMSPayment = ({ onChange }): JSX.Element => {
  const [isLoading, setLoading] = useState(false);// 是否正在加载页面数据
  const [currentTabKey, setCurrentTabKey] = useState('aliay');// tabs默认高亮设置 wechat-微信支付 / aliay-支付宝支付 / duigong-对公账户
  // 支付宝列表
  const [zfbList, setZZfbList] = useState([]);
  // const [dataSource, setDataSource] = useState([{ id: "", number: 0, marketPrice: 0, discountPrice: 0, univalence: 0, score: 0 }]);//列表数据
  const [dataSource_account, setDataSource_account] = useState([]);// 列表数据_对公账户
  const [payNum, serPayNum] = useState(0);// 用户充值条数
  const [autoCalculatePrice, setAutoCalculatePrice] = useState({ currentDiscountPrice: 0, currentUnivalence: 0 });// currentDiscountPrice - 特惠价 currentUnivalence - 分/条
  const [smsTotalNum, setSMSTotalNum] = useState(0); // 短信剩余条数
  const [qqDialog, setQqDialog] = useState(false); // 联系客服dialog
  /** 生命周期函数 */
  useEffect(() => {
    init();
  }, []);

  /** 初始化函数 */
  const init = (): void => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 500);

    getSmsnum();

    // 获取优惠套餐列表
    // shopId: 4463798
    Servlets('getAccountPayment', { shopId: Cookie.get('shopId') }).then((res) => {
      setZZfbList(res.data.doudianDiscountPackageList);
    });
  };

  const getSmsnum = () => {
    // 获取 页面获取短信余额方法
    Servlets('getPageSmsNum').then((res) => {
      setSMSTotalNum(res.data);
    });
  };

  /** 获取 列表数据格式配置项 */
  // const getColumns = (): Array<object> => {
  //     const columns = [
  //         {
  //             title: "短信条数",
  //             dataIndex: "number",
  //             width: 180,
  //             alignHeader: 'left',
  //             align: 'left'
  //         },
  //         {
  //             title: "市场价（元）",
  //             dataIndex: "marketPrice",
  //             width: 180,
  //             alignHeader: 'left',
  //             align: 'left'
  //         },
  //         {
  //             title: "特惠价（元）",
  //             dataIndex: "discountPrice",
  //             width: 180,
  //             alignHeader: 'left',
  //             align: 'left',
  //             cell: (value, index, record) => {
  //                 return <div style={{ color: 'red' }}>{value}</div>
  //             }
  //         },
  //         {
  //             title: "单价（分/条）",
  //             dataIndex: "univalence",
  //             width: 180,
  //             alignHeader: 'left',
  //             align: 'left',
  //             cell: (value, index, record) => {
  //                 return <div>{value}分/条</div>
  //             }
  //         },
  //         {
  //             title: "评分",
  //             dataIndex: "score",
  //             width: 180,
  //             alignHeader: 'left',
  //             align: 'left',
  //             cell: (value, index, record) => {
  //                 return <div>
  //                     {
  //                         [1, 2, 3, 4, 5].map((item) => {
  //                             return (<Icon key={item} type="favorites-filling" style={{ color: item > value ? '#ddd' : '#ff9800', fontSize: 14 }} size="xs" />)
  //                         })
  //                     }
  //                 </div>
  //             }
  //         },
  //         {
  //             title: "操作",
  //             lock: 'right',
  //             width: 180,
  //             alignHeader: 'left',
  //             align: 'left',
  //             cell: (value, index, record) => {
  //                 return <div style={{ userSelect: 'none' }}>
  //                     {
  //                         <Button type="primary" text onClick={() => { immediatelyPayFunc(record) }}>立即充值</Button>
  //                     }
  //                 </div>
  //             }
  //         },
  //     ];
  //     return columns;
  // }
  /**
   *
   * @param data
   * @returns  向上取整两位小数
   */
  const upFloat = (data) => {
    const num = data * 1000;
    const result = Math.ceil(num) / 1000;
    if (String(result).substring(String(result).indexOf('.')).length > 3) {
      return Math.round(result * 100) / 100;
    } else {
      return result;
    }
  };
  /**
   *  页面tabs切换时触发
   * @param tabKey
   */
  const changeTabs = (tabKey: string): void => {
    setCurrentTabKey(tabKey);
  };
  // 监听用户输入短信条数
  const handleChangePayNum = (val): void => {
    serPayNum(val);
    const result = { currentDiscountPrice: 0, currentUnivalence: 0 };

    if (!val) { // 当用户清除输入框数值后，重置特惠价及单价
      setAutoCalculatePrice(result);
      return;
    }
    console.log(val, 'duanxin', val * 0.1);
    if (val < 1000) {
      result.currentDiscountPrice = (val * 0.1).toFixed(1);
      result.currentUnivalence = 0.1;
    } else if (val >= 1000 && val < 5000) {
      result.currentDiscountPrice = upFloat(val * 0.085);
      result.currentUnivalence = 0.085;
    } else if (val >= 5000 && val < 10000) {
      result.currentDiscountPrice = upFloat(val * 0.08);
      result.currentUnivalence = 0.08;
    } else if (val >= 10000) {
      result.currentDiscountPrice = upFloat(val * 0.06);
      result.currentUnivalence = 0.06;
    } else if (val > 10000000) {
      LzMsg.error('超过最大重置上限');
    }
    // // 判断当前val应该匹配那种优惠规则
    // let tempIndex = zfbList.findIndex((item) => {
    //     // return val < item.maxQuantity;
    // })

    // switch (tempIndex) {

    //     case -1://优惠套餐中没有比用户输入的条数更大的数值了，直接最优惠价格安排上
    //         result.currentUnivalence = zfbList[zfbList.length - 1].price;//单价
    //         break;
    //     case 0://这里说明 用户输入的短信条数 小于最小优惠
    //         result.currentUnivalence = zfbList[0].price;
    //         break;
    //     default:
    //         result.currentUnivalence = zfbList[tempIndex - 1].price;
    //         break;
    // }

    // result.currentDiscountPrice = Math.floor(result.currentUnivalence * 10) / 10 * val / 100;//折扣价

    // Math.floor(result.currentUnivalence * 10) / 10 防止精度失真 升级后降级
    setAutoCalculatePrice(result);
  };

  // 用户点击快捷充值
  const immediatelyPayFunc = (record: { id: string; number: number; marketPrice: number; discountPrice: number; univalence: number; score: number }) => {
    serPayNum(record.number);
    handleChangePayNum(record.number);

    immediatelyPay(record.number);
  };
  // 立即充值
  const immediatelyPay = (num: number) => {
    if (!num) {
      Message.warning('请输入您将要充值的短信条数');
      return;
    }

    const firstChargeFlag = 2; // 1-首充，2-不是首充
    // payNum-充值条数 currentUnivalence-单条价格 firstChargeFlag-是否在本系统是首次充值
    window.open(`./accountKeeper/sms/payDeal/ali/${autoCalculatePrice.currentUnivalence}/${num}/${firstChargeFlag}`, '_blank');
  };
  // 跳转至充值记录
  const redirectPayRecord = () => {
    onChange('SMSPaymentRecord');
  };

  return (
    <>
      <Loading visible={isLoading} fullScreen>
        {
          <div className={style.SMSPayment}>
            <img src="//img10.360buyimg.com/imgzone/jfs/t1/283134/25/17141/47109/67f767c5F544bde64/cc20cc764a2767f9.jpg" alt="" />
            <div className={style.pageInfoNotice}>
              <div>
                <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
                <div>
                  <p>1.短信充值支持线上扫码支付，也可以联系客服以线下转账的形式进行充值；</p>
                  <p>2.短信充值后永久有效，请放心使用；</p>
                </div>
              </div>
              <div>
                <Button
                  type="primary"
                  className={style.submitBtnStyle_width}
                  style={{ marginRight: 6 }}
                  onClick={redirectPayRecord}
                >充值记录
                </Button>
              </div>
            </div>

            <div className={style.surplusNum}>
              <div className={style.item}>
                <div className={style.intro}>
                  <span style={{ fontSize: 14 }}>短信总量</span>
                  <span style={{ fontSize: 30, color: 'red', marginTop: 8 }}>{smsTotalNum}</span>
                </div>
                <Button
                  type="primary"
                  text
                  onClick={() => {
                    getSmsnum();
                  }}
                >刷新
                </Button>
              </div>
              <div className={style.item}>
                <div className={style.intro}>
                  <span style={{ fontSize: 14 }}>开具发票</span>
                  <span style={{
                    fontSize: 12,
                    color: '#bbb',
                    marginTop: 8,
                  }}
                  >通知：开具发票只支持9月份短信改版后所产生的交易
                  </span>
                </div>
                <Button
                  type="primary"
                  text
                  onClick={() => {
                    window.open(
                      'https://admin.qidian.qq.com/template/blue/mp/menu/qr-code-jump.html?linkType=0&env=ol&kfuin=2852153664&fid=36&key=9618c1ef96579400e1e481819a96716e&cate=1&type=16&ftype=1&_type=wpa&qidian=true',
                    );
                  }}
                >联系客服
                </Button>
              </div>
            </div>
            {/* <Dialog
              title="联系客服："
              visible={qqDialog}
              footerActions={['ok']}
              onOk={() => {
                window.open("http://amos.alicdn.com/getcid.aw?v=2&uid=%E6%B3%8A%E6%BA%90%E7%A7%91%E6%8A%80&site=cntaobao&s=1&groupid=0&charset=utf-8")
                setQqDialog(false);
              }}
              onClose={() => {
                setQqDialog(false);
              }}
              style={{ width: '300px' }}
            >
              QQ：2708146020
            </Dialog> */}
            <div className={style.tabs}>
              <Tab
                size="small"
                shape="capsule"
                navClassName="smsPayment_tabs"
                onChange={changeTabs}
                defaultActiveKey={currentTabKey}
                animation
              >
                {/* <TabItem title="微信支付" key="wechat" disabled>
                                    <p className={style.content}>
                                        <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />由于微信付款每日有额度上限，建议提前核对可支付额度，大批量短信充值建议使用对公转账方式
                                    </p>
                                </TabItem> */}
                <TabItem title="支付宝支付" key="aliay">
                  <p className={style.content}>
                    <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
                    由于支付宝支付每日有额度上限，建议提前核对可支付额度，大批量短信充值建议使用对公转账方式
                  </p>
                </TabItem>
                <TabItem title="对公转账" key="duigong">
                  <p className={style.content}>
                    <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
                    注意：选择短信对公转账，请及时将回执单截图给客服，客服核实款项到账后，手动充值。
                  </p>
                </TabItem>
              </Tab>
            </div>


            {
              ['wechat', 'aliay'].includes(currentTabKey) && (
                <div>
                  <div className={style.quickPayment}>
                    <ParagraphTitle title="自助充值" subtitle="" />
                    <div className={style.operationPay}>

                      <span style={{ marginTop: '-13px' }}>短信条数：<span
                        style={{ color: 'red' }}
                      >{payNum || '- -'}
                                                                </span>&nbsp;条
                      </span>

                      <span>特惠价：<span
                        style={{ color: 'red' }}
                      >{autoCalculatePrice.currentDiscountPrice ? autoCalculatePrice.currentDiscountPrice : '- -'}
                      </span>&nbsp;元
                      </span>

                      <span>单价：<span
                        style={{ color: 'red' }}
                      >{autoCalculatePrice.currentUnivalence ? autoCalculatePrice.currentUnivalence : '- -'}
                      </span>&nbsp;元/条
                      </span>

                      <div>
                        <label>
                          <span>充值条数：</span>
                          <NumberPicker
                            value={payNum || undefined}
                            onChange={handleChangePayNum}
                            style={{ width: 400 }}
                            min={0}
                            max={10000000}
                          />
                        </label>
                        <Button
                          type="primary"
                          className={style.submitBtnStyle_width}
                          style={{ marginLeft: 10 }}
                          onClick={() => immediatelyPay(payNum)}
                        >立即充值
                        </Button>
                      </div>
                    </div>
                  </div>

                  <div className={style.mainBox}>
                    <div className={style.formAndListStyle}>

                      <ParagraphTitle title="优惠套餐" subtitle="" />

                      {/* 列表 */}
                      <div className={style.listContent}>

                        <div style={{ marginTop: 8 }}>
                          <Table dataSource={zfbList} fixedHeader maxBodyHeight={460}>
                            <Table.Column
                              title="短信条数（条）"
                              dataIndex="maxQuantity"
                              align="left"
                            />
                            <Table.Column
                              title="市场价（元）"
                              dataIndex="originalPrice"
                              align="left"
                            />
                            <Table.Column
                              title="特惠价（元）"
                              dataIndex="realPrice"
                              align="left"
                              cell={(value, index, item) => {
                                return (<div style={{ color: '#FF3333' }}>
                                  {item.realPrice}
                                </div>);
                              }}
                            />
                            <Table.Column title="单价（元/条）" dataIndex="price" align="left" />
                            <Table.Column
                              title="评分"
                              dataIndex="id"
                              align="left"
                              cell={(value, index, item) => {
                                return (<div>
                                  {index === 3 &&
                                  <Rating
                                    size="small"
                                    value={3}
                                    readOnly
                                  />
                                              }
                                  {index === 4 &&
                                  <Rating
                                    size="small"
                                    value={4}
                                    readOnly
                                  />
                                              }
                                  {index === 5 &&
                                  <Rating
                                    size="small"
                                    value={5}
                                    readOnly
                                  />
                                              }
                                </div>);
                              }}
                            />
                            <Table.Column
                              title="操作"
                              dataIndex="id"
                              align="left"
                              cell={(value, index, item) => {
                                return (<div style={{ color: '#FF3333' }}>
                                  <Button
                                    text
                                    type="primary"
                                    onClick={() => window.open(`./accountKeeper/sms/payDeal/ali/${item.price}/${item.maxQuantity}/${2}`, '_blank')}
                                  >立即充值
                                  </Button>
                                </div>);
                              }}
                            />
                          </Table>
                        </div>

                      </div>
                    </div>
                  </div>

                  <p style={{
                    color: '#c6cdd6',
                    marginTop: 12,
                    height: 40,
                  }}
                  >注：充值短信为特殊商品，不支持任何形式的退款哦~充值的短信余额是永久有效的。
                  </p>

                </div>
              )
            }

            {
              ['duigong'].includes(currentTabKey) && (
                <div className={style.OfThePublic}>
                  <div className={`${style.commonBox} ${style.account}`}>
                    <ParagraphTitle title="转账账号" subtitle="" />
                    <div className={style.account_table}>
                      <Table dataSource={list}>
                        <Table.Column align="center" title="公司名称" dataIndex="companyName"/>
                        <Table.Column align="center" title="对公账户" dataIndex="account"
                          cell={(value, index, record)=>{
                            return (
                              <span>{record.account}</span>
                            )
                          }}
                        />
                        <Table.Column align="center" title="联行号" dataIndex="unionNumber"
                          cell={(value, index, record)=>{
                            return (
                              <span>{record.unionNumber}</span>
                            )
                          }}
                        />
                        <Table.Column align="center" title="开户行" dataIndex="accountBank"
                          cell={(value, index, record)=>{
                            return (
                              <span>{record.accountBank}</span>
                            )
                          }}
                        />
                      </Table>
                    </div>
                  </div>
                  <div className={`${style.commonBox} ${style.large}`}>
                    <ParagraphTitle title="量大从优" subtitle="" />
                    <div
                      className={style.large_box}
                      onClick={() => {
                        window.open(
                          'https://admin.qidian.qq.com/template/blue/mp/menu/qr-code-jump.html?linkType=0&env=ol&kfuin=2852153664&fid=36&key=9618c1ef96579400e1e481819a96716e&cate=1&type=16&ftype=1&_type=wpa&qidian=true',
                        );
                      }}
                    >
                      <div className={style.quickChannel} >
                        <div className={style.pay}>
                          <span style={{
                            color: '#fff',
                            fontSize: '18px',
                            fontWeight: 'bold',
                          }}
                          >超值优惠充值通道
                          </span>

                        </div>
                        <div className={style.communication}>
                          <span style={{
                            color: '#464C5B',
                            fontSize: '18px',
                            fontWeight: 'bold',
                          }}
                          >充值量越大越便宜
                          </span>
                          <span style={{
                            position: 'relative',
                            bottom: '-45px',
                            right: '-41px',
                          }}
                          >QQ交谈：
                          </span>
                        </div>
                      </div>

                      <div className={style.pageInfoNotice}>
                        <div>
                          <Icon
                            type="prompt"
                            size="small"
                            style={{ color: '#f0b447', marginRight: 8 }}
                          />
                          <div>
                            <p>1.支持开具增值税发票，如需开票请联系客服开具。
                              <span
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  window.open(
                                    'https://admin.qidian.qq.com/template/blue/mp/menu/qr-code-jump.html?linkType=0&env=ol&kfuin=2852153664&fid=36&key=9618c1ef96579400e1e481819a96716e&cate=1&type=16&ftype=1&_type=wpa&qidian=true',
                                  );
                                }}
                              >
                                【联系客服】
                              </span>
                            </p>
                            <p>2.短信可跨店铺、跨平台使用，订购量大可返利，具体可联系客服哦。
                              <span
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  window.open(
                                    'https://admin.qidian.qq.com/template/blue/mp/menu/qr-code-jump.html?linkType=0&env=ol&kfuin=2852153664&fid=36&key=9618c1ef96579400e1e481819a96716e&cate=1&type=16&ftype=1&_type=wpa&qidian=true',
                                  );
                                }}
                              >
                                【联系客服】
                              </span>
                            </p>
                            <p>3.短信购买后永久生效。如若软件过期，续订成功后历史剩余短信可继续使用。</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }


          </div>

        }
      </Loading>

    </>
  );
};

export default SMSPayment;
